import { useEffect, useState } from "react";
import { _CreditOpening, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { InputDate } from "../../../theme/Input/InputDate";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { ListPropsParameters } from "./ListPropsParameters/ListPropsParameters";
import { ListPropsLoans } from "./ListPropsLoans/ListPropsLoans";
import { FileInput } from "../../../theme/Component/FileInput";


const In_Edition = 1;
const In_Approbe = 2;
const In_Open = 3;
const In_Paused = 4;
const In_Finished = 5;

export const CreditOpening = () => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_CreditOpening);
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalConfigProps, setModalConfigProps] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalConfigLoans, setModalConfigLoans] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        let props = {}
        instance.getCreditOpeningCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => {
            toast.error(err)
        })

    }

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true, name: "Crear Apertura de Crédito" });
    }

    const deleteItem = () => {
        instance.deleteCreditOpening(bean.IDCreditOpening).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        instance.updateCreditOpening(bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
                setModalConfigLoans({ ...modalConfigLoans, "view": false });
                setModalConfigProps({ ...modalConfigProps, "view": false });

            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDCreditOpening', visible: true,mask:MASK_NUMBER },
        { title: 'Monto Apertura', property: 'AmountOpening', visible: true,mask:MASK_MONEY },
        { title: 'Fecha Apertura', property: 'FromDate', visible: true,mask:MASK_DATE },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Fecha Cierre', property: 'UptoDate', visible: true ,mask:MASK_DATE},
        { title: 'Hora apertura', property: 'FromHour', visible: true },
        { title: 'Porcentaje Pausa', property: 'CuotePercent', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar Apertura de Crédito`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
            { titulo: 'Parametros de apertura', icono: 'ri-search-line', visible: true, evento: () => { setModalConfigProps({ ...modalConfigProps, "view": true, "name": "Configuracion Demografica" }) } },
            { titulo: 'Lineas de Crédito de apertura', icono: 'ri-search-line', visible: true, evento: () => { setModalConfigLoans({ ...modalConfigLoans, "view": true, "name": "Configuracion de Lineas de Credito" }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const stateOptions = [
        { value: In_Edition, label: "En Edición" },
        { value: In_Approbe, label: "Aprobado" },
        { value: In_Open, label: "Abierto" },
        { value: In_Paused, label: "Pausado" },
        { value: In_Finished, label: "Finalizado" }
    ];


    return (
        <BasicPage titulo="Apertura Crédito">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />
                </div>
            </div>


            <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                <div className="row">
                    <div className="col-md-6">
                        <label>Nombre</label>
                        <input type="text" className="form-control" value={bean.Name} onChange={(e) => setBean({ ...bean, Name: e.target.value })} />
                    </div>
                    <div className="col-md-6">
                        <label>Imagen del Banner</label>
                        <FileInput onCreate={({ Media, MediaContext, Name }) => { setBean({ ...bean, "BanerImage": JSON.stringify({ MediaContext: MediaContext, Media: Media, Name: Name }) }) }} />
                    </div>
                    <div className="col-md-12">
                        <label>Descripción</label>
                        <textarea className="form-control" value={bean.Description} onChange={(e) => setBean({ ...bean, Description: e.target.value })} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="" value={bean.FromDate} label="Fecha Apertura" setDate={(e) => setBean({ ...bean, FromDate: e })} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="" value={bean.UptoDate} label="Fecha Cierre" setDate={(e) => setBean({ ...bean, UptoDate: e })} />
                    </div>

                    <div className="col-md-6">
                        <label>Hora Apertura</label>
                        <select className="form-select" value={bean.FromHour} onChange={(e) => setBean({ ...bean, FromHour: e.target.value })} >
                            <option value="">Seleccione</option>
                            {Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0')).map((hour) => (
                                <option key={hour} value={hour}>{hour}</option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-6">
                        <label>Monto Apertura</label>
                        {/* <input type="number" className="form-control" value={bean.AmountOpening ?? ''} onChange={(e) => setBean({ ...bean, AmountOpening: Number(e.target.value) })} min={1} /> */}
                         <InputMoney _label="Reintegro" _value={bean.AmountOpening} onChange={(e) => { setBean({ ...bean, "AmountOpening": e }) }} />
                    </div>

                    <div className="col-md-6">
                        <label>Porcentaje Pausa</label>
                        <input
                            type="number"
                            className="form-control"
                            value={bean.CuotePercent ?? ''}
                            onChange={(e) => {
                                const value = Number(e.target.value);
                                if (value >= 1 && value <= 100) {
                                    setBean({ ...bean, CuotePercent: value });
                                } else {
                                    setBean({ ...bean, CuotePercent: null });
                                    toast.error("El porcentaje debe estar entre 1 y 100");
                                }
                            }}
                        />
                    </div>

                    <div className="col-md-6">
                        <label>Estado</label>
                        <select
                            className="form-select"
                            value={bean.State ?? ''}
                            onChange={(e) => setBean({ ...bean, State: Number(e.target.value) })}
                        >
                            {stateOptions.map(({ value, label }) => (
                                <option key={value} value={value}>
                                    {label}
                                </option>
                            ))}
                        </select>
                    </div>

                </div>
            </Modal>

            <Modal modal={modalConfigProps} updateModal={setModalConfigProps} eventModal={() => { editaItem() }} >
                <ListPropsParameters jsonProps={bean.JSONProps} onChange={(e) => { setBean({ ...bean, JSONProps: e }) }} />
            </Modal>

            <Modal modal={modalConfigLoans} updateModal={setModalConfigLoans} eventModal={() => { editaItem() }} >
                <ListPropsLoans jsonProps={bean.JSONLoans} onChange={(e) => { setBean({ ...bean, JSONLoans: e }) }} />
            </Modal>

            <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                <strong>Eliminar item</strong>
            </ModalConfirm>

        </BasicPage>
    )
}